import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './components/loginForm/LoginForm';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import './App.css';
import Dashboard from './components/dashboard/dashboard';
import ResultPage from './components/Resultpage/ResultPage';
import DigiLockerResultPage from './components/digilocker/DigiLockerResultPage'; 
import DigiLockerResultPage2 from './components/digilocker/DigiLockerResultPage2'; 

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    const userString = localStorage.getItem('user');

    if (token && userString) {
      setIsAuthenticated(true);
      try {
        const user = JSON.parse(userString);
        setUsername(user.username || user.name || user.displayName || 'Tommy');
      } catch (error) {
        console.error('Failed to parse user data from localStorage:', error);
        setUsername('User');
      }
    } else {
      setIsAuthenticated(false);
      setUsername('');
      if (token) localStorage.removeItem('jwtToken');
      if (userString) localStorage.removeItem('user');
    }
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('jwtToken', token);
    localStorage.setItem('user', JSON.stringify(userData));

    setIsAuthenticated(true);
    setUsername(userData.username || userData.name || userData.displayName || 'User');

    console.log('Login successful! Authentication state and username updated.');
  };

  const handleLogout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUsername('');
    console.log('User logged out. Authentication state updated.');
  };

  return (
    /// adding this for result.mduedu.org -> result folder
    // <Router basename="/result">
    <Router>



      {/* </Router>*/}



       {/* Basename admin is added for the cisceu-react-app bucket otherwise there will be no basename */} 

  
      <Routes>
        {/* Paths are now absolute from the domain root */}
        <Route path="/auth/login" element={<LoginForm onLogin={handleLogin} />} />

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Dashboard onLogout={handleLogout} username={username} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/result"
          element={<ResultPage />}
        />

        {/* NEW DIGITAL LOCKER RESULT PAGE ROUTE */}
        <Route path="/digilocker/result" 
        element={<DigiLockerResultPage />} /> {/* <--- NEW ROUTE */}

        {/* NEW DIGITAL LOCKER RESULT PAGE ROUTE */}
        <Route path="/digilocker/results" 
        element={<DigiLockerResultPage2 />} /> {/* <--- NEW ROUTE */}

        {/* The root path for the app is now "/" */}
        <Route
          path="/"
          element={<LoginForm />}
        />

        {/* Catch-all route will also redirect to full absolute paths */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/admin/dashboard" : "/auth/login"} replace />} />
      </Routes>
    </Router>
  );
}

export default App;


// uncomment below code while deploying digi locker



// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import LoginForm from './components/loginForm/LoginForm';
// import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
// import './App.css';
// import Dashboard from './components/dashboard/dashboard';
// import ResultPage from './components/Resultpage/ResultPage';
// import DigiLockerResultPage from './components/digilocker/DigiLockerResultPage'; 
// import DigiLockerResultPage2 from './components/digilocker/DigiLockerResultPage2'; 

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [username, setUsername] = useState('');

//   useEffect(() => {
//     const token = localStorage.getItem('jwtToken');
//     const userString = localStorage.getItem('user');

//     if (token && userString) {
//       setIsAuthenticated(true);
//       try {
//         const user = JSON.parse(userString);
//         setUsername(user.username || user.name || user.displayName || 'Tom');
//       } catch (error) {
//         console.error('Failed to parse user data from localStorage:', error);
//         setUsername('User');
//       }
//     } else {
//       setIsAuthenticated(false);
//       setUsername('');
//       if (token) localStorage.removeItem('jwtToken');
//       if (userString) localStorage.removeItem('user');
//     }
//   }, []);

//   const handleLogin = (token, userData) => {
//     localStorage.setItem('jwtToken', token);
//     localStorage.setItem('user', JSON.stringify(userData));

//     setIsAuthenticated(true);
//     setUsername(userData.username || userData.name || userData.displayName || 'User');

//     console.log('Login successful! Authentication state and username updated.');
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('jwtToken');
//     localStorage.removeItem('user');
//     setIsAuthenticated(false);
//     setUsername('');
//     console.log('User logged out. Authentication state updated.');
//   };

//   return (
//     // <Router basename="/admin">
//      <Router> 
//        {/* Basename admin is added for the cisceu-react-app bucket otherwise there will be no basename */} 

  
//       <Routes>
//         {/* Paths are now absolute from the domain root */}
//         <Route path="/auth/login" element={<DigiLockerResultPage onLogin={handleLogin} />} />

//         {/* <Route
//           path="/admin/dashboard"
//           element={
//             <ProtectedRoute isAuthenticated={isAuthenticated}>
//               <DigiLockerResultPage onLogout={handleLogout} username={username} />
//             </ProtectedRoute>
//           }
//         /> */}

//         <Route
//           path="/result"
//           element={<ResultPage />}
//         />

//         {/* NEW DIGITAL LOCKER RESULT PAGE ROUTE */}
//         <Route path="/digilocker/result" 
//         element={<DigiLockerResultPage />} /> {/* <--- NEW ROUTE */}

//         {/* NEW DIGITAL LOCKER RESULT PAGE ROUTE */}
//         <Route path="/digilocker/results" 
//         element={<DigiLockerResultPage2 />} /> {/* <--- NEW ROUTE */}

//         {/* The root path for the app is now "/" */}
//         <Route
//           path="/"
//           element={<DigiLockerResultPage />}
//         />

//        {/* Catch-all route will also redirect to full absolute paths */}
//                <Route path="*" element={<Navigate to={isAuthenticated ? "/admin/dashboard" : "/auth/login"} replace />} />
//              </Routes>
//     </Router>
//   );
// }

// export default App;